import { render } from "./taxes.vue?vue&type=template&id=02db2194&scoped=true"
import script from "./taxes.vue?vue&type=script&lang=js"
export * from "./taxes.vue?vue&type=script&lang=js"

import "./taxes.vue?vue&type=style&index=0&id=02db2194&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02db2194"]])

export default __exports__